import { render, staticRenderFns } from "./ListPrestationOfInstitution.vue?vue&type=template&id=3ee881a7&scoped=true"
import script from "./ListPrestationOfInstitution.vue?vue&type=script&lang=js"
export * from "./ListPrestationOfInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee881a7",
  null
  
)

export default component.exports